import Cookies from 'js-cookie';
import { UserLocalStorageKeysEnum } from '../interfaces/user.interface';

const getCookieDomain = (): string | undefined => {
  const overrideDomain = process.env.REACT_APP_COOKIE_DOMAIN;
  if (overrideDomain) return overrideDomain;

  if (typeof window === 'undefined') {
    return undefined;
  }

  const hostname = window.location.hostname;
  if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') {
    return undefined;
  }

  const isIpAddress = hostname
    .split('.')
    .every((segment) => /^\d+$/.test(segment));
  if (isIpAddress) {
    return undefined;
  }

  const segments = hostname.split('.');
  if (segments.length < 2) {
    return `.${hostname}`;
  }

  const baseDomain = segments.slice(-2).join('.');
  return `.${baseDomain}`;
};

// Cookie configuration for token storage
const TOKEN_COOKIE_OPTIONS = {
  expires: 7, // 7 days
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict' as const,
  path: '/',
  domain: getCookieDomain(),
};

export class TokenCookieManager {
  // Set token in cookie
  static setToken(token: string): void {
    Cookies.set(UserLocalStorageKeysEnum.TOKEN, token, TOKEN_COOKIE_OPTIONS);
  }

  // Get token from cookie
  static getToken(): string | undefined {
    return Cookies.get(UserLocalStorageKeysEnum.TOKEN);
  }

  // Remove token from cookie
  static removeToken(): void {
    Cookies.remove(UserLocalStorageKeysEnum.TOKEN, { path: '/' });
  }

  // Check if token exists
  static hasToken(): boolean {
    return !!this.getToken();
  }

  // Migrate token from localStorage to cookies (one-time migration)
  static migrateTokenFromLocalStorage(): void {
    const token = localStorage.getItem(UserLocalStorageKeysEnum.TOKEN);
    if (token && !this.hasToken()) {
      this.setToken(token);
      localStorage.removeItem(UserLocalStorageKeysEnum.TOKEN);
    }
  }
}
